import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ITablePagerOptions} from 'app/main/shared/shared/table/components/table-pager/ITablePagerOptions';
import {Observable} from 'rxjs';
import * as ContentLibraryStoreAction from './content-library-store.action';
import * as ContentLibraryStoreSelector from './content-library-store.selector';

@Injectable({
    providedIn: 'root'
})

export class ContentLibraryStoreFacade {
    
    public contents$ = this._store$.select(ContentLibraryStoreSelector.contents);
    public allContents$ = this._store$.select(ContentLibraryStoreSelector.allContents);
    public content$ = this._store$.select(ContentLibraryStoreSelector.content);
    public fetchContentLibraryRequestState$ = this._store$.select(ContentLibraryStoreSelector.fetchContentLibraryRequestState);
    public addContentLiraryRequest$ = this._store$.select(ContentLibraryStoreSelector.addContentRequestState);
    public updateContentLiraryRequest$ = this._store$.select(ContentLibraryStoreSelector.updateContentRequestState);
    search$: Observable<string> = this._store$.select(ContentLibraryStoreSelector.search);
    paging$: Observable<ITablePagerOptions> = this._store$.select(ContentLibraryStoreSelector.paging);
    constructor (private _store$: Store) {}

    fetchAllContentLibraries(page:string) {
        this._store$.dispatch(ContentLibraryStoreAction.fetchAllContentLibrary(page))
    }

    fetchContentLibrary() {
        this._store$.dispatch(ContentLibraryStoreAction.fetchContentLibrary())
    }

    onSearchChange(searchValue: string) {
        this._store$.dispatch(ContentLibraryStoreAction.searchChange(searchValue));
    }

    changePage(pageNumber: number): void {
        this._store$.dispatch(ContentLibraryStoreAction.changePage(pageNumber));
    }

    addContentLibrary(formData:IAddContentLibraryForm){
        this._store$.dispatch(ContentLibraryStoreAction.addContentLibrary({formData}));
    }

    updateContentLibrary(formData:IEditContentLibraryForm){
        this._store$.dispatch(ContentLibraryStoreAction.updateContentLibrary({formData}))
    }

    deleteContent(id:number){
        this._store$.dispatch(ContentLibraryStoreAction.deleteContent(id));
    }

    clearContentLibraryState(){
        this._store$.dispatch(ContentLibraryStoreAction.clearState())
    }
}

export interface IAddContentLibraryForm {
    name: string,
    content: string,
    field_data
}

export interface IEditContentLibraryForm extends IAddContentLibraryForm {
    id:number
}
